import { render, staticRenderFns } from "./divider-secondary.vue?vue&type=template&id=ba959d48&scoped=true&"
import script from "./divider-secondary.vue?vue&type=script&lang=js&"
export * from "./divider-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba959d48",
  null
  
)

export default component.exports